import { c as _c } from "react/compiler-runtime";
import { ApiWave } from "@/generated/models/ApiWave";
import FollowersListWrapper from "@/components/utils/followers/FollowersListWrapper";
import { useWaveFollowers } from "@/hooks/useWaveFollowers";
export default function WaveFollowersList(t0) {
  const $ = _c(11);
  const {
    wave,
    onBackClick
  } = t0;
  const {
    followers,
    isFetching,
    onBottomIntersection
  } = useWaveFollowers(wave.id);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-flex-shrink-0 tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    t2 = <span>Back</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onBackClick) {
    t3 = <button onClick={onBackClick} className="tw-py-2 tw-px-2 -tw-ml-2 tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-text-sm tw-font-semibold tw-border-0 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out tw-cursor-pointer tw-text-iron-400 tw-bg-transparent hover:tw-text-iron-50">{t1}{t2}</button>;
    $[2] = onBackClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== followers || $[5] !== isFetching || $[6] !== onBottomIntersection) {
    t4 = <FollowersListWrapper followers={followers} loading={isFetching} onBottomIntersection={onBottomIntersection} />;
    $[4] = followers;
    $[5] = isFetching;
    $[6] = onBottomIntersection;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="tw-w-full tw-px-4 tw-py-2 tw-bg-iron-950 tw-min-h-full tw-rounded-b-xl lg:tw-rounded-b-none">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}